export const removeCurrencyFormatting = (value: string) => {
  if (!value) return "0";
  return value.replace(/,/g, "");
};
